import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { CompanyServiceService } from 'src/app/share/services/company-service/company-service.service';
import { MasterMakeService } from 'src/app/share/services/master-make/master-make.service';
import { MasterModelService } from 'src/app/share/services/master-model/master-model.service';
import { ReturnsService } from 'src/app/share/services/returns/returns.service';
import { StockService } from 'src/app/share/services/stock/stock.service';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { RegExpPatterns } from 'src/app/share/enums/regex-pattern.enum';
import { MessageService } from 'src/app/share/sharedsubject';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { PaymentAccountsService } from 'src/app/share/services/payment-account/payment-accounts.service';

@Component({
    selector: 'app-return-from-customer',
    templateUrl: './return-from-customer.component.html',
    styleUrls: ['./return-from-customer.component.scss'],
    standalone: false
})
export class ReturnFromCustomerComponent implements OnInit {

  protected readonly faPlus = faPlus;
  protected readonly faTrash = faTrash;

  customSearchFn = () => true;
  returnToCustomerForm: FormGroup;
  filteredActiveBranches: any[] = [];
  isLoading = false;
  tyreSizeObj: any={page:0, searchTerm: '', list: []};
  userDetails:any;
  tyreMakeObj:any={page:0, searchTerm: '', list: []};
  tyreModelObj:any={page:0}
  resMsg:string;
  tyreModelList: { search: string, list: any[], page: number }[] = [{ search: '', list: [], page: 0 }];

  showStockArray = false;
  isFromInvoice = false;

  paymentModes = [
    { label: 'UPI', value: 'UPI' },
    { label: 'Cash', value: 'Cash' },
    { label: 'Bank Transfer', value: 'BankTransfer' },
    { label: 'Card', value: 'Card' },
    { label: 'Bajaj Finance', value: 'BajajFinance'},
  ];
  paymentAccountsList: any[] = [];
  paymentAccountsLoading = false;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly stockService: StockService,
    private readonly masterModelService: MasterModelService,
    private readonly masterMakeService: MasterMakeService,
    private readonly companyService: CompanyServiceService,
    private readonly returnsService: ReturnsService,
    private readonly storageService: StorageService,
    private readonly router: Router,
    private readonly messageService: MessageService,
    private readonly paymentAccountsService: PaymentAccountsService,
  ){
    this.returnToCustomerForm = this.formBuilder.group({
      toBranch: this.userDetails?.enrollmentType === 'Company' ? [null, Validators.required] : [null],
      invoiceNumber: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(30)]],
      customerPhone: [null, [Validators.required, Validators.pattern(RegExpPatterns.MobilePattern)]],
      stock: this.formBuilder.array([this.returnDetailsGroup()]),
      paymentMode: ['UPI', Validators.required],
      paymentAccount: [null, Validators.required]
    })
  }

  returnDetailsGroup(item?: any): FormGroup {
    let quantityVal = null;
    let priceVal = null;

    if (item) {
      quantityVal = item.editedQuantity ?? item.quantity;
      priceVal = item.editedtyresAmount ?? item.tyresAmount;
    }

    return this.formBuilder.group({
      tyreSize: [item ? item.tyreSize : null, Validators.required],
      tyreMake: [item ? item.tyreMake : null, Validators.required],
      tyreModel: [item ? item.tyreModel : null],
      quantity: [
        quantityVal,
        [
          Validators.required,
          Validators.min(1),
          ...(item ? [Validators.max(quantityVal)] : [])
        ]
      ],
      purchasingPrice: [
        priceVal,
        [
          Validators.required,
          Validators.min(1),
          ...(item ? [Validators.max(priceVal)] : [])
        ]
      ]
    });
  }

  get stock(): FormArray {
    return this.returnToCustomerForm.get('stock') as FormArray;
  }

  addItem(index: number): void {
    this.stock.push(this.returnDetailsGroup());
    this.tyreModelList.push({ search: '', list: [], page: 0 });
  }

  removeItem(index: number): void {
    this.stock.removeAt(index);
    this.tyreModelList.splice(index, 1);
  }

  ngOnInit(): void {
    this.userDetails = this.storageService.getDataFromLocalStorage(
      StorageKeys.SELF_DETAILS
    );
    if(this.userDetails?.enrollmentType === 'Company'){
      this.getAllCompanyList();
      this.returnToCustomerForm.get('toBranch')?.setValidators([Validators.required]);
      this.returnToCustomerForm.get('toBranch')?.setValue(null, { emitEvent: false });
    } else {
      this.returnToCustomerForm.get('toBranch')?.setValue(this.userDetails?.company);
      this.loadPaymentAccounts();
    }
    this.initData();
  }

  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length > 10) {
      inputElement.value = inputElement.value.slice(0, 10);
      this.returnToCustomerForm.controls['customerPhone'].setValue(inputElement.value);
    }
  }

  onInvoiceInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    let val = inputElement.value;
    if (val.startsWith(' ')) {
      val = val.trimStart();
      inputElement.value = val;
      this.returnToCustomerForm.controls['invoiceNumber'].setValue(val);
    }
  }

  onInvoiceChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const trimmed = inputElement.value.trim();
    inputElement.value = trimmed;
    this.returnToCustomerForm.controls['invoiceNumber'].setValue(trimmed);
  }

  getAllCompanyList() {
    this.companyService.getToCompanyList().subscribe((res: any) => {
      this.filteredActiveBranches = res.data?.filter((c: any) => c.status === 'Active') || [];
    });
  }

  get totalAmount(): number {
    let total = 0;
    const stockArray = this.stock?.value || [];
    stockArray.forEach((item: any) => {
      const qty = Number(item.quantity) || 0;
      const amt = Number(item.purchasingPrice) || 0;
      total += qty * amt;
    });
    return total;
  }

  onBranchChange() {
    this.loadPaymentAccounts();
  }

  loadPaymentAccounts() {
    const branch = this.returnToCustomerForm.value.toBranch;
    const mode = this.returnToCustomerForm.value.paymentMode;
    if (!branch || !mode) {
      this.paymentAccountsList = [];
      this.returnToCustomerForm.get('paymentAccount')?.setValue(null);
      return;
    }

    this.paymentAccountsLoading = true;
    this.paymentAccountsService.getCompanyPaymentAccount({
      company: branch, paymentType: mode, page: 0,
      status: true, sort: '_id', sortDir: 1
    }).subscribe({
      next: (res: any) => {
        this.paymentAccountsLoading = false;
        this.paymentAccountsList = res.data || [];
        
        const defaultAcc = this.paymentAccountsList.find((a: any) => a.default);
        if (defaultAcc) {
          this.returnToCustomerForm.get('paymentAccount')?.setValue(defaultAcc._id);
        } else if (this.paymentAccountsList.length > 0) {
          this.returnToCustomerForm.get('paymentAccount')?.setValue(this.paymentAccountsList[0]._id);
        } else {
          this.returnToCustomerForm.get('paymentAccount')?.setValue(null);
        }
      },
      error: () => {
        this.paymentAccountsLoading = false;
        this.paymentAccountsList = [];
        this.returnToCustomerForm.get('paymentAccount')?.setValue(null);
      }
    });
  }

  onSubmit() {
    if (this.showStockArray) {
      this.saveReturnData();
    } else {
      this.fetchInvoiceData();
    }
  }

  fetchInvoiceData() {
    if (this.isLoading) return;
    this.resMsg = '';
    this.isLoading = true;
    const params = {
      company: this.returnToCustomerForm.value.toBranch,
      invoiceNumber: this.returnToCustomerForm.value.invoiceNumber,
    };
    this.stockService.getStockDataByInvoice(params).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.resMsg = '';
        this.showStockArray = true;
        const invoiceData = res.data;
        if (invoiceData?.stock?.length) {
          this.isFromInvoice = true;
           const stockFormArray = this.stock;
          stockFormArray.clear();
          this.tyreModelList = [];

          invoiceData.stock.forEach((item: any, index: number) => {
            stockFormArray.push(this.returnDetailsGroup(item));
            this.tyreModelList.push({ search: '', list: [{ name: item.tyreModel }], page: 0 });
          });
          this.loadPaymentAccounts();
        } else {
          this.isFromInvoice = false;
          const stockFormArray = this.stock;
          stockFormArray.clear();
          this.tyreModelList = [];
          stockFormArray.push(this.returnDetailsGroup());
          this.tyreModelList.push({ search: '', list: [], page: 0 });
          this.initData();
          this.loadPaymentAccounts();
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        this.resMsg = error?.error?.error?.message || error?.error?.message || 'Failed to fetch invoice details';
        this.showStockArray = false;
        this.isFromInvoice = false;
      }
    });
  }

  saveReturnData() {
    if (this.returnToCustomerForm.invalid || this.isLoading) return;
    this.resMsg = '';
    this.isLoading = true;
    let form = this.returnToCustomerForm.value
    const payload = {
      totalAmount: this.totalAmount,
      toBranch: form.toBranch,
      invoiceNumber: form.invoiceNumber,
      customerPhone: form.customerPhone,
      stock: form.stock,
      paymentAccounts: [{ paymentId: form.paymentAccount, amount: this.totalAmount, mode: form.paymentMode }]
    };

    this.returnsService.stockReturnFromCustomer(payload).subscribe({
      next: (res: any) => {
      setTimeout(() => {
        this.messageService.sendMessage(res.message);
      });
      this.router.navigate(['/product-list']);
      this.isLoading = false;
      this.resMsg = res.message;
    },
      error: (error) => {
      this.isLoading = false;
      this.resMsg = error?.error?.error?.message || error?.error?.message || 'Failed to submit return details';
    }
    });
  }


  getTyreSize() {
    const apiParams: any = { page: this.tyreSizeObj.page };
    if (this.tyreSizeObj.searchTerm) {
      apiParams.searchTerm = this.tyreSizeObj.searchTerm;
    }
    this.stockService.getTyreDetails(apiParams).subscribe((res: any) => {
      if (this.tyreSizeObj.page === 0) {
        this.tyreSizeObj.list = res.data || [];
      } else {
        this.tyreSizeObj.list = [...this.tyreSizeObj.list, ...(res.data || [])];
      }
    });
  }

  getTyreModel(selectedMake:any, index: number ){
    this.masterModelService.getTyreModelList(selectedMake, this.tyreModelObj).subscribe((res:any) => {
      if (this.tyreModelObj.page == 0) {

        this.tyreModelList[index].list = res.data || []
      }
      else {
        this.tyreModelList[index].list = this.tyreModelList[index].list.concat(res.data || []);
      }
    });
  }

  getTyreMake() {
    this.masterMakeService.getTyreMakeBySize(this.tyreMakeObj.page, this.tyreMakeObj.searchTerm).subscribe((res: any) => {
      if (this.tyreMakeObj.page === 0) {
        this.tyreMakeObj.list = res.data || [];
      } else {
        this.tyreMakeObj.list = [...this.tyreMakeObj.list, ...(res.data || [])];
      }
    });
  }



  onScrollTyreSize() {
    if (this.tyreSizeObj.list.length % 20 === 0) {
      this.tyreSizeObj.page++;
      this.getTyreSize();
    }
  }

  onTyreSizeInputChange(event: any) {
    this.tyreSizeObj.page = 0;
    let tyreSizeSearch = event?.term ? event.term : '';
    this.tyreSizeObj.searchTerm = tyreSizeSearch;
    this.tyreSizeObj.list = [];
    this.getTyreSize();
  }

  onTyreMakeInputChange(event: any) {
    this.tyreMakeObj.page = 0;
    let tyreMakeSearch = event?.term ? event.term : '';
    this.tyreMakeObj.searchTerm = tyreMakeSearch;
    this.tyreMakeObj.list = [];
    this.getTyreMake();
  }

  selectMake(value:any, index: any){
    let selectedTyreMake = value || '';
    let selectedTyre: any = this.stock?.controls[index];
    selectedTyre?.controls['tyreModel'].setValue(null);
    this.tyreModelObj.name = '';
    this.tyreModelObj.tyreMake= selectedTyreMake;
    this.tyreModelObj.page = 0;
    this.tyreModelList[index].page = 0;
    this.tyreModelList[index].search = '';
    this.tyreModelList[index].list = [];
    if (value) {
      this.getTyreModel(this.tyreModelObj, index);
    }
  }

  scroll(index: number){
    if (this.tyreModelList[index].list.length % 20 === 0) {
      let selectedGroup: any = this.stock?.controls[index];
      let selectedTyreMake = selectedGroup?.controls['tyreMake'].value;
      this.tyreModelObj.tyreMake = selectedTyreMake;
      this.tyreModelObj.name = this.tyreModelList[index].search;
      this.tyreModelList[index].page++;
      this.tyreModelObj.page = this.tyreModelList[index].page;
      this.getTyreModel(this.tyreModelObj, index)
    }
  }

  onTyreModelInputChange(event:any, index: number){
    this.tyreModelObj.page=0;
    this.tyreModelList[index].page=0;
    let tyreModelSearch = event?.term ? event.term : '';
    this.tyreModelObj.name = tyreModelSearch;
    this.tyreModelList[index].search = tyreModelSearch;
    let selectedGroup: any = this.stock?.controls[index];
    let selectedTyreMake = selectedGroup?.controls['tyreMake'].value;
    this.tyreModelObj.tyreMake = selectedTyreMake;
    this.getTyreModel(this.tyreModelObj, index);
  }

  initData() {
    this.tyreSizeObj.page = 0;
    this.tyreSizeObj.searchTerm = "";
    this.tyreMakeObj.searchTerm = "";
    this.tyreModelObj.name = "";
    this.tyreModelObj.page = 0;
    this.getTyreSize();
    this.getTyreMake();
  }

  onSizeClose() {
    if (this.tyreSizeObj.searchTerm) {
      this.tyreSizeObj.page = 0;
      this.tyreSizeObj.searchTerm = '';
      this.getTyreSize();
    }
  }

  onMakeClose() {
    if (this.tyreMakeObj.searchTerm) {
      this.tyreMakeObj.page = 0;
      this.tyreMakeObj.searchTerm = '';
      this.getTyreMake();
    }
  }

  onModelClose(index: number) {
    if (this.tyreModelList[index].search) {
      this.tyreModelList[index].page = 0;
      this.tyreModelList[index].search = '';
      
      this.tyreModelObj.page = 0;
      this.tyreModelObj.name = '';
      
      let selectedGroup: any = this.stock?.controls[index];
      let selectedTyreMake = selectedGroup?.controls['tyreMake'].value;
      this.tyreModelObj.tyreMake = selectedTyreMake;
      
      this.getTyreModel(this.tyreModelObj, index);
    }
  }


}

